import { render, staticRenderFns } from "./FaqPreview.vue?vue&type=template&id=10562b7e&scoped=true"
import script from "./FaqPreview.vue?vue&type=script&lang=js"
export * from "./FaqPreview.vue?vue&type=script&lang=js"
import style0 from "./FaqPreview.vue?vue&type=style&index=0&id=10562b7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10562b7e",
  null
  
)

export default component.exports